/** Проверка доступности серверного проекта для текущего пользователя. */
import { queryOptions, useQuery } from "@tanstack/react-query";
import { Api } from "@/api";
import { projectsKeys } from "./keys";

export const projectDataOptions = (userId: string | null, projectId: string | null) =>
	queryOptions({
		queryKey: projectsKeys.data(userId, projectId),
		queryFn: () => {
			if (projectId === null) throw new Error("Не указан проект");
			return Api.Project.getApiProjectsDataById({ id: projectId });
		},
		networkMode: "always",
		retry: false,
	});

export const useProjectData = (
	userId: string | null,
	projectId: string | null,
	enabled: boolean,
) => {
	const query = useQuery({
		...projectDataOptions(userId, projectId),
		enabled: enabled && userId !== null && projectId !== null,
		refetchOnMount: "always",
	});

	return {
		response: query.data ?? null,
		isChecking: query.isFetching || !query.isFetchedAfterMount,
		isError: query.isError,
		refetch: query.refetch,
	};
};
